// ============================================================================
// env.js — a futó kiadás környezete (dev / prod).
//
// Az értéket NEM ez a fájl határozza meg: a build (client/build.mjs) az
// env/<név>.json tartalmát fordítja bele a csomagba a __LINEAGE_ENV__
// azonosító helyére. Így ugyanaz a forráskód készíti a tesztváltozatot és a
// kiadott változatot, és a kettő között kizárólag ez az egy érték különbözik.
//
// Csomagolás nélkül (pl. az automatikus tesztekben) a __LINEAGE_ENV__ nem
// létezik; ilyenkor a "test" tartalékérték él - az sosem "prod", tehát
// véletlenül sem viselkedik kiadott változatként.
// ============================================================================

/* global __LINEAGE_ENV__ */

const FALLBACK = {
  name: "test",
  appName: "Lineage0 (TEST)",
  shortName: "L0 TEST",
  themeColor: "#e8710a",
  firebase: {},
  vapidKey: "",
};

export const ENV = typeof __LINEAGE_ENV__ !== "undefined" ? __LINEAGE_ENV__ : FALLBACK;

/** Igaz, ha ez a kiadott, éles változat. */
export const IS_PROD = ENV.name === "prod";
